<script>
import LaboratoryStateMixin from '@/modules/laboratoryModule/mixins/laboratoryStateMixin'
import { PortionOperationGuardMixin } from '@/api/operations/mixins/guards/portion-operation-guard.mixin'
import { SubportionOperationGuardMixin } from '@/api/operations/mixins/guards/subportion-operation-guard.mixin'
import { ENTITIES_LABORATORY } from '@/modules/laboratoryModule/config/sidebarConfig'

export default {
    name: 'LaboratoryOptionGuardsMixin',
    mixins: [
        LaboratoryStateMixin,
        PortionOperationGuardMixin,
        SubportionOperationGuardMixin
    ],
    computed: {
        canProcessElementsOfSelectedOption() {
            if (this.selectedOption && this.selectedOption.actionUrl &&
                !this.selectedOption.elementWithoutOperation
            ) {
                if (this.selectedOption.additionalRequiredPermissions) {
                    return this.selectedOption.additionalRequiredPermissions.every(
                        permission => this.hasOperationInCurrentLaboratoryGlobalMixin(permission)
                    )
                }
                return true
            }
            return false
        },
        canUndoLastOperationOfSelectedSidebarOption() {
            if (!this.getUndoUrlOfSelectedOption()) {
                return false
            }
            switch (this.selectedOption.typeAlt || this.selectedOption.type) {
            case ENTITIES_LABORATORY.SAMPLE:
                return false
            case ENTITIES_LABORATORY.PORTION:
                return this.$_canUndoLastPortionOperation()
            case ENTITIES_LABORATORY.SUBPORTION:
                return this.$_canUndoLastSubportionOperation()
            default:
                return false
            }
        }
    },
    methods: {
        getUndoUrlOfSelectedOption() {
            if (!this.selectedOption) {
                return null
            }
            switch (this.selectedOption.typeAlt || this.selectedOption.type) {
            case ENTITIES_LABORATORY.SAMPLE:
                return null
            case ENTITIES_LABORATORY.PORTION:
                return 'portions/undo'
            case ENTITIES_LABORATORY.SUBPORTION:
                return 'portions/subportions/undo'
            default:
                return null
            }
        },
        getIdHierarchyFromPortion(portion) {
            return {
                caseId: portion.sample.caseStudy.casId,
                portionId: portion.porId,
                sampleId: portion.sample.samId
            }
        },
        getIdHierarchyFromSubportion(subportion) {
            return {
                caseId: subportion.portion.sample.caseStudy.casId,
                portionId: subportion.portion.porId,
                sampleId: subportion.portion.sample.samId,
                subportionId: subportion.supId
            }
        }
    }
}
</script>
